import React from 'react';
import { DepositGuaranteeBanner } from './DepositGuaranteeBanner';
import { useDepositGuaranteePromo } from './useDepositGuaranteePromo';
import { LivingPlusBanner } from '@/components/content/livingPlusBanner/LivingPlusBanner';

export const MeinPlusPromotion = () => {
  const tab = useDepositGuaranteePromo();
  return tab ? <DepositGuaranteeBanner tab={tab} /> : <LivingPlusBanner />;
};
